// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FirstBlock_root__lBIcf {
  padding: 40px 0;
  background: #00377c;
}
.FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh {
  min-height: calc(100vh - 134px);
  padding: 40px 0;
}
.FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX {
  display: flex;
}
.FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus {
  margin-right: -178px;
  white-space: nowrap;
  z-index: 1;
}
.FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_titleBlock__0MKHj p {
  color: #fff;
}
.FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_titleBlock__0MKHj p:first-child {
  padding: 0 20px 0 0;
  font-size: 40px;
  font-weight: bold;
  background: #00377c;
  border-radius: 20px;
}
.FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_titleBlock__0MKHj p:last-child {
  font-size: 20px;
  margin-top: 10px;
}
.FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_btnPresentationBlock__q--Cz {
  margin-top: 80px;
}
.FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_btnPresentationBlock__q--Cz a {
  text-decoration: underline;
  color: #fff;
  background: none;
  border: none;
}
.FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_btnPresentationBlock__q--Cz a img {
  width: 32px;
  margin-right: 10px;
}
.FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_imageBlock__2HQgv img {
  max-width: 100%;
  border-radius: 50px;
}

@media (max-width: 991px) {
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX {
    flex-direction: column-reverse;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus {
    margin: 10px 0 0 0;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_titleBlock__0MKHj p:first-child {
    padding: 0;
    font-size: 32px;
    background: none;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_titleBlock__0MKHj p:last-child {
    font-size: 16px;
    margin-top: 5px;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_btnPresentationBlock__q--Cz {
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_btnPresentationBlock__q--Cz button img {
    width: 28px;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_imageBlock__2HQgv {
    display: flex;
    justify-content: center;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_imageBlock__2HQgv img {
    max-width: 80%;
    border-radius: 30px;
  }
}
@media (max-width: 768px) {
  .FirstBlock_root__lBIcf {
    padding: 20px 0;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh {
    min-height: calc(100vh - 85px);
    padding: 20px 0;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_titleBlock__0MKHj p:first-child {
    font-size: 25px !important;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_titleBlock__0MKHj p:last-child {
    font-size: 14px !important;
    margin-top: 5px;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_btnPresentationBlock__q--Cz {
    margin-top: 20px;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_btnPresentationBlock__q--Cz button {
    font-size: 14px;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_btnPresentationBlock__q--Cz button img {
    width: 26px;
  }
}
@media (max-width: 575px) {
  .FirstBlock_root__lBIcf {
    padding: 20px 0;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh {
    min-height: calc(100vh - 80px);
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_titleBlock__0MKHj p:first-child {
    font-size: 20px !important;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_titleBlock__0MKHj p:last-child {
    font-size: 12px !important;
    margin-top: 0;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_btnPresentationBlock__q--Cz {
    margin-top: 30px;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_btnPresentationBlock__q--Cz button {
    font-size: 12px;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_titleBtnBlock__DpFus .FirstBlock_btnPresentationBlock__q--Cz button img {
    width: 20px;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_imageBlock__2HQgv {
    margin: 0 -12px;
  }
  .FirstBlock_root__lBIcf .FirstBlock_wrapper__ACqyh .FirstBlock_titleImageBlock__iaIXX .FirstBlock_imageBlock__2HQgv img {
    max-width: 100%;
    border-radius: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MainBlock/FirstBlock/FirstBlock.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,mBAAA;AACF;AACE;EACE,+BAAA;EACA,eAAA;AACJ;AACI;EACE,aAAA;AACN;AACM;EACE,oBAAA;EACA,mBAAA;EACA,UAAA;AACR;AAEU;EACE,WAAA;AAAZ;AAEY;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AAAd;AAGY;EACE,eAAA;EACA,gBAAA;AADd;AAMQ;EACE,gBAAA;AAJV;AAMU;EACE,0BAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AAJZ;AAMY;EACE,WAAA;EACA,kBAAA;AAJd;AAWQ;EACE,eAAA;EACA,mBAAA;AATV;;AAgBA;EAGM;IACE,8BAAA;EAfN;EAiBM;IACE,kBAAA;EAfR;EAmBY;IACE,UAAA;IACA,eAAA;IACA,gBAAA;EAjBd;EAoBY;IACE,eAAA;IACA,eAAA;EAlBd;EAuBQ;IACE,aAAA;IACA,uBAAA;IACA,gBAAA;EArBV;EAwBY;IACE,WAAA;EAtBd;EA4BM;IACE,aAAA;IACA,uBAAA;EA1BR;EA4BQ;IACE,cAAA;IACA,mBAAA;EA1BV;AACF;AAiCA;EACE;IACE,eAAA;EA/BF;EAiCE;IACE,8BAAA;IACA,eAAA;EA/BJ;EAqCY;IACE,0BAAA;EAnCd;EAsCY;IACE,0BAAA;IACA,eAAA;EApCd;EAyCQ;IACE,gBAAA;EAvCV;EAyCU;IACE,eAAA;EAvCZ;EAyCY;IACE,WAAA;EAvCd;AACF;AAgDA;EACE;IACE,eAAA;EA9CF;EAgDE;IACE,8BAAA;EA9CJ;EAoDY;IACE,0BAAA;EAlDd;EAqDY;IACE,0BAAA;IACA,aAAA;EAnDd;EAwDQ;IACE,gBAAA;EAtDV;EAwDU;IACE,eAAA;EAtDZ;EAwDY;IACE,WAAA;EAtDd;EA4DM;IACE,eAAA;EA1DR;EA4DQ;IACE,eAAA;IACA,gBAAA;EA1DV;AACF","sourcesContent":[".root {\n  padding: 40px 0;\n  background: #00377c;\n\n  .wrapper {\n    min-height: calc(100vh - 134px);\n    padding: 40px 0;\n\n    .titleImageBlock {\n      display: flex;\n\n      .titleBtnBlock {\n        margin-right: -178px;\n        white-space: nowrap;\n        z-index: 1;\n\n        .titleBlock {\n          p {\n            color: #fff;\n\n            &:first-child {\n              padding: 0 20px 0 0;\n              font-size: 40px;\n              font-weight: bold;\n              background: #00377c;\n              border-radius: 20px;\n            }\n\n            &:last-child {\n              font-size: 20px;\n              margin-top: 10px;\n            }\n          }\n        }\n\n        .btnPresentationBlock {\n          margin-top: 80px;\n\n          a {\n            text-decoration: underline;\n            color: #fff;\n            background: none;\n            border: none;\n\n            img {\n              width: 32px;\n              margin-right: 10px;\n            }\n          }\n        }\n      }\n\n      .imageBlock {\n        img {\n          max-width: 100%;\n          border-radius: 50px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 991px) {\n  .root {\n    .wrapper {\n      .titleImageBlock {\n        flex-direction: column-reverse;\n\n        .titleBtnBlock {\n          margin: 10px 0 0 0;\n\n          .titleBlock {\n            p {\n              &:first-child {\n                padding: 0;\n                font-size: 32px;\n                background: none;\n              }\n\n              &:last-child {\n                font-size: 16px;\n                margin-top: 5px;\n              }\n            }\n          }\n\n          .btnPresentationBlock {\n            display: flex;\n            justify-content: center;\n            margin-top: 50px;\n\n            button {\n              img {\n                width: 28px;\n              }\n            }\n          }\n        }\n\n        .imageBlock {\n          display: flex;\n          justify-content: center;\n\n          img {\n            max-width: 80%;\n            border-radius: 30px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    padding: 20px 0;\n\n    .wrapper {\n      min-height: calc(100vh - 85px);\n      padding: 20px 0;\n\n      .titleImageBlock {\n        .titleBtnBlock {\n          .titleBlock {\n            p {\n              &:first-child {\n                font-size: 25px !important;\n              }\n\n              &:last-child {\n                font-size: 14px !important;\n                margin-top: 5px;\n              }\n            }\n          }\n\n          .btnPresentationBlock {\n            margin-top: 20px;\n\n            button {\n              font-size: 14px;\n\n              img {\n                width: 26px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 575px) {\n  .root {\n    padding: 20px 0;\n\n    .wrapper {\n      min-height: calc(100vh - 80px);\n\n      .titleImageBlock {\n        .titleBtnBlock {\n          .titleBlock {\n            p {\n              &:first-child {\n                font-size: 20px !important;\n              }\n\n              &:last-child {\n                font-size: 12px !important;\n                margin-top: 0;\n              }\n            }\n          }\n\n          .btnPresentationBlock {\n            margin-top: 30px;\n\n            button {\n              font-size: 12px;\n\n              img {\n                width: 20px;\n              }\n            }\n          }\n        }\n\n        .imageBlock {\n          margin: 0 -12px;\n\n          img {\n            max-width: 100%;\n            border-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `FirstBlock_root__lBIcf`,
	"wrapper": `FirstBlock_wrapper__ACqyh`,
	"titleImageBlock": `FirstBlock_titleImageBlock__iaIXX`,
	"titleBtnBlock": `FirstBlock_titleBtnBlock__DpFus`,
	"titleBlock": `FirstBlock_titleBlock__0MKHj`,
	"btnPresentationBlock": `FirstBlock_btnPresentationBlock__q--Cz`,
	"imageBlock": `FirstBlock_imageBlock__2HQgv`
};
export default ___CSS_LOADER_EXPORT___;
